import { useCopilotStore } from '../../stores/copilotStore'

interface Props {
  callSid: string
  // Accepted for API symmetry with the other co-pilot panels; this panel has
  // no interactive controls, so it renders the same either way.
  readOnly?: boolean
}

export function SentimentGauge({ callSid }: Props) {
  const sentiment = useCopilotStore((s) => s.byCallSid[callSid]?.sentiment ?? null)

  const score = sentiment?.score ?? 0
  // Map -1..+1 to 0..100 for the bar width.
  const pct = Math.round(((score + 1) / 2) * 100)
  const colorClass =
    score > 0.25
      ? 'bg-green-500'
      : score < -0.25
      ? 'bg-red-500'
      : 'bg-yellow-500'

  return (
    <section className="rounded-lg border border-border bg-surface-card p-4">
      <header className="mb-3 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-text-primary">Customer sentiment</h3>
        <span className="text-xs text-text-secondary">
          {sentiment ? score.toFixed(2) : '—'}
        </span>
      </header>
      <div className="h-2 w-full overflow-hidden rounded-full bg-surface-elevated">
        <div
          className={`h-full ${colorClass} transition-all duration-300`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {sentiment?.evidence && (
        <p className="mt-3 text-xs italic text-text-secondary">
          “{sentiment.evidence}”
        </p>
      )}
      {!sentiment && (
        <p className="mt-3 text-xs text-text-secondary">
          Listening…
        </p>
      )}
    </section>
  )
}
